import isNil from 'lodash/isNil';
import { endingSlashRE, outboundRE } from '../util';
export default {
  name: 'PageEdit',
  computed: {
    tags() {
      return this.$frontmatter.tags;
    },
    lastUpdated() {
      return this.$page.lastUpdated;
    },
    lastUpdatedText() {
      if (typeof this.$themeLocaleConfig.lastUpdated === 'string') {
        return this.$themeLocaleConfig.lastUpdated;
      }
      if (typeof this.$site.themeConfig.lastUpdated === 'string') {
        return this.$site.themeConfig.lastUpdated;
      }
      return 'Last Updated';
    },
    editLink() {
      const showEditLink = isNil(this.$page.frontmatter.editLink) ? this.$site.themeConfig.editLinks : this.$page.frontmatter.editLink;
      const {
        repo,
        docsDir = '',
        docsBranch = 'master',
        docsRepo = repo
      } = this.$site.themeConfig;
      if (showEditLink && docsRepo && this.$page.relativePath) {
        return this.createEditLink(repo, docsRepo, docsDir, docsBranch, this.$page.relativePath);
      }
      return null;
    },
    editLinkText() {
      return this.$themeLocaleConfig.editLinkText || this.$site.themeConfig.editLinkText || `Edit this page`;
    }
  },
  methods: {
    createEditLink(repo, docsRepo, docsDir, docsBranch, path) {
      const bitbucket = /bitbucket.org/;
      if (bitbucket.test(docsRepo)) {
        const base = docsRepo;
        return base.replace(endingSlashRE, '') + `/src` + `/${docsBranch}/` + (docsDir ? docsDir.replace(endingSlashRE, '') + '/' : '') + path + `?mode=edit&spa=0&at=${docsBranch}&fileviewer=file-view-default`;
      }
      const gitlab = /gitlab.com/;
      if (gitlab.test(docsRepo)) {
        const base = docsRepo;
        return base.replace(endingSlashRE, '') + `/-/edit` + `/${docsBranch}/` + (docsDir ? docsDir.replace(endingSlashRE, '') + '/' : '') + path;
      }

      // https://gitee.com/-/ide/project/xxx/xxx/edit/master/-/xxxx
      const gitee = /gitee.com/;
      if (gitee.test(docsRepo)) {
        const base = docsRepo;
        return base.replace(gitee, 'gitee.com/-/ide/project') + `/edit` + `/${docsBranch}/-/` + (docsDir ? docsDir.replace(endingSlashRE, '') + '/' : '') + path;
      }
      const base = outboundRE.test(docsRepo) ? docsRepo : `https://github.com/${docsRepo}`;
      return base.replace(endingSlashRE, '') + `/edit` + `/${docsBranch}/` + (docsDir ? docsDir.replace(endingSlashRE, '') + '/' : '') + path;
    }
  }
};